var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import MuiSelect from "@material-ui/core/Select";
import { XCircleIcon } from "../icon";
import { IconButton } from "../icon-button";
import { InputAdornment } from "../input-adornment";
import { SelectMenu } from "../select-menu";
import { makeStyles } from "../styles";
import { Text } from "../text";
import clsx from "../utils/clsx";
import { renderSelectOptions } from "./select-options";
var useStyles = makeStyles(function (theme) { return ({
    selectionDisabled: {
        color: theme.palette.text.secondary,
    },
    rootAdornedEnd: {
        // reset the normal padding
        paddingRight: 0,
        "& > $select": {
            paddingRight: theme.spacing(9),
        },
        "&$sizeSmall > $select": {
            paddingRight: theme.spacing(8),
        },
    },
    sizeSmall: {},
    select: {},
    clearAdornment: {
        position: "absolute",
        right: theme.spacing(4),
    },
}); }, { name: "CosmosSelect" });
export var Select = React.forwardRef(function (_a, ref) {
    var options = _a.options, children = _a.children, value = _a.value, defaultValue = _a.defaultValue, className = _a.className, size = _a.size, margin = _a.margin, onClear = _a.onClear, multiple = _a.multiple, prefix = _a.prefix, useCustomMenu = _a.useCustomMenu, _b = _a.MenuProps, MenuProps = _b === void 0 ? {} : _b, rootProps = __rest(_a, ["options", "children", "value", "defaultValue", "className", "size", "margin", "onClear", "multiple", "prefix", "useCustomMenu", "MenuProps"]);
    var classes = useStyles();
    var compareValue = value || defaultValue;
    var disabledOptionSelected = !!options && !multiple && !!options.find(function (option) { return option.value === compareValue && option.disabled; });
    var hasValue = multiple && Array.isArray(compareValue) ? !!compareValue.length : !disabledOptionSelected;
    var hasClearButton = !!onClear && hasValue;
    return (React.createElement(MuiSelect, __assign({ ref: ref, value: value, defaultValue: defaultValue, margin: size === "small" ? "dense" : margin, multiple: multiple, classes: {
            select: classes.select,
        }, className: clsx(disabledOptionSelected && classes.selectionDisabled, hasClearButton && classes.rootAdornedEnd, (size === "small" || margin === "dense") && classes.sizeSmall, className), endAdornment: hasClearButton && (React.createElement(InputAdornment, { position: "end", className: classes.clearAdornment },
            React.createElement(IconButton, { size: size, onClick: onClear },
                React.createElement(XCircleIcon, null)))), startAdornment: !!prefix && (React.createElement(InputAdornment, { position: "start" },
            React.createElement(Text, { component: "span", variant: "body2" }, prefix))), MenuProps: useCustomMenu
            ? __assign({ anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "right",
                }, transformOrigin: {
                    vertical: "top",
                    horizontal: "right",
                } }, MenuProps) : MenuProps }, rootProps), useCustomMenu ? (React.createElement(SelectMenu, null, children)) : !!options ? (renderSelectOptions({ options: options, value: value || defaultValue })) : (children)));
});
